import chroma from "chroma-js";

export function colorIsDark(bgColor) {
    const contrastWhite = chroma.contrastAPCA("#FFFFFF", bgColor);
    const contrastBlack = chroma.contrastAPCA("#000000", bgColor);
    return Math.abs(contrastBlack) < Math.abs(contrastWhite);
}
